// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Modules
import { DeleteFaqConfirmModal } from '@/modules/FaqCommon';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { deleteGeneralFaqs, selectGeneralFaqsIsLoading } from '../feature';

type TBulkDeleteGeneralFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  chosenFaqIds: string[];
  resetSelection: () => void;
  onDeleted: () => void;
};

const BulkDeleteGeneralFaqModal: FC<TBulkDeleteGeneralFaqModalProps> = ({
  isOpen,
  onClose,
  chosenFaqIds,
  resetSelection,
  onDeleted,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectGeneralFaqsIsLoading);

  const handleBulkDeleteGeneralFaq = async () => {
    try {
      await dispatch(deleteGeneralFaqs({ faqIds: chosenFaqIds })).unwrap();
      onClose();
      resetSelection();
      onDeleted();
    } catch {}
  };

  return (
    <DeleteFaqConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleBulkDeleteGeneralFaq}
      isLoading={isLoading}
      title={t('bulk_delete_faq_confirm', { count: chosenFaqIds.length })}
      description={t('delete_description')}
    />
  );
};

export default BulkDeleteGeneralFaqModal;
